import apiClient from './client';

export interface Feedback {
  id: string;
  user_id: string;
  telegram_user_id: number;
  subject?: string;
  message: string;
  rating?: number;
  created_at: string;
  updated_at: string;
}

export interface CreateFeedbackRequest {
  subject?: string;
  message: string;
  rating?: number;
}

export const feedbackApi = {
  /**
   * Создать обращение в обратную связь
   */
  create: async (data: CreateFeedbackRequest): Promise<Feedback> => {
    const response = await apiClient.post<Feedback>('/feedback', data);
    return response.data;
  },

  /**
   * Получить историю обращений пользователя
   */
  getUserFeedback: async (userId: string): Promise<Feedback[]> => {
    const response = await apiClient.get<Feedback[]>(`/users/${userId}/feedback`);
    return response.data;
  },
};
